import {
  getCLS, getFID, getFCP, getLCP,
} from 'web-vitals';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

const collectWebVitals = (data) => {
  triggerCustomEvent(events.snowplow.webVitalsReport, data);
};

window.addEventListener('DOMContentLoaded', () => {
  getFCP(collectWebVitals);
  getCLS(collectWebVitals, true);
  getFID(collectWebVitals);
  getLCP(collectWebVitals);
});
